var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useState } from "react";
import Dropzone from "react-dropzone";
import { Button } from "../Button";
const formats = [
    "pdf",
    "zip",
    "png",
    "jpg",
    "jpeg",
    "vnd.openxmlformats-officedocument.wordprocessingml.document",
];
export const DragDropModal = (props) => {
    const [imgInfo, setImgInfo] = useState({});
    const dropHandler = useCallback((event) => __awaiter(void 0, void 0, void 0, function* () {
        if (!(event === null || event === void 0 ? void 0 : event.length))
            return;
        const imgRawInfo = {
            blobFile: event[0],
            name: event[0].name,
            size: event[0].size / 1000000,
            type: event[0].type.split("/")[1].toString(),
        };
        setImgInfo(imgRawInfo);
        props.dragDropHandler(imgRawInfo);
    }), [props.dragDropHandler]);
    return (React.createElement("div", { style: { marginTop: "5px", marginBottom: 15 } },
        React.createElement("div", { className: "tempModalTxt" },
            React.createElement(Dropzone, { onDrop: dropHandler }, ({ getRootProps, getInputProps }) => (React.createElement("div", Object.assign({}, getRootProps({ className: "dropzone" })),
                React.createElement("input", Object.assign({}, getInputProps())),
                React.createElement("div", { className: "uploadWrapContainer" },
                    React.createElement("div", { className: "drop-it-hot", id: "drop-area" },
                        React.createElement("form", { className: "choose-files", style: { textAlign: "center" } },
                            React.createElement(DragDropIcon, null),
                            React.createElement("div", { className: "button-wrapper", style: { marginTop: 10 } },
                                React.createElement("label", { className: "label dragDropLabel", htmlFor: "fileElem", style: {
                                        width: "31%",
                                        textAlign: "center",
                                        fontWeight: "bold",
                                        color: "black",
                                    } }, "Drag and drop file or"),
                                React.createElement("br", null),
                                React.createElement("div", { className: "file-ui-wrapper", style: {
                                        position: "relative",
                                        height: "40px",
                                        marginTop: 20,
                                        marginBottom: "15px",
                                    } },
                                    React.createElement("label", { htmlFor: "raised-button-file" },
                                        React.createElement(Button, { label: "Browse", variant: "outlined" })),
                                    React.createElement("div", { className: "wordWrap", style: {
                                            color: "green",
                                            cursor: "pointer",
                                            textAlign: "center",
                                            marginTop: 10,
                                        } },
                                        imgInfo.name ? imgInfo.name : null,
                                        !imgInfo.name && props.imgPath ? (React.createElement("a", { href: props.imgPath, target: "_blank" }, props.imgPath.name || props.imgPath)) : null),
                                    React.createElement("br", null),
                                    ((imgInfo === null || imgInfo === void 0 ? void 0 : imgInfo.size) || 0) > 25 ? (React.createElement("div", { style: {
                                            color: "red",
                                            marginBottom: 3,
                                            textAlign: "center",
                                        } }, "File size exceeds the maximum limit.")) : null,
                                    imgInfo.type && !formats.includes(imgInfo.type) && (React.createElement("div", { style: {
                                            color: "red",
                                            marginBottom: 3,
                                            textAlign: "center",
                                        } }, "File type not supported.")),
                                    React.createElement("div", { style: { textAlign: "center", fontWeight: "500" } },
                                        "Maximum file size: 25MB",
                                        React.createElement("br", null),
                                        " Supported file types: JPG,PNG,DOC,PDF,ZIP")),
                                React.createElement("div", { style: { height: "80px" } })))))))))));
};
const DragDropIcon = () => (React.createElement("svg", { fill: "currentColor", height: "25", viewBox: "0 0 24 24", width: "25", xmlns: "http://www.w3.org/2000/svg", style: { color: "#BFBFBF" } },
    React.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
    React.createElement("path", { d: "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" })));
